// ngb-tabset.component.ts
import {
  Component,
  ContentChildren,
  QueryList,
  AfterContentInit,
  Input,
  Output,
  EventEmitter,
  OnChanges,
  SimpleChanges,
  HostBinding
} from '@angular/core';
import { NgbTabComponent } from './ngb-tab.component';

@Component({
    selector: 'ngb-tabset',
    exportAs: 'ngbTabset',
    template: `
    <ul class="nav nav-tabs" [ngClass]="navClasses">
      <li
        class="nav-item"
        *ngFor="let tab of tabs"
        [class.disabled]="tab.disabled"
        (click)="selectTab(tab)"
      >
        <a
          href="#"
          class="nav-link"
          [class.active]="tab.id === activeId"
          (click)="$event.preventDefault()"
        >
           <ng-container *ngIf="tab.customTitleTpl; else defaultTitle">
            <ng-container
              *ngTemplateOutlet="tab.customTitleTpl.templateRef"
            ></ng-container>
          </ng-container>
          <ng-template #defaultTitle>{{ tab.title }}</ng-template>
        </a>
      </li>
    </ul>

    
    <div class="tab-content">
      <div class="tab-pane fade show active" *ngIf="activeTab?.contentTpl?.templateRef">
          <ng-container [ngTemplateOutlet]="activeTab.contentTpl.templateRef"></ng-container>
      </div>
    </div>
  `,
    standalone: false
})
export class NgbTabsetComponent implements AfterContentInit, OnChanges {
  @ContentChildren(NgbTabComponent) tabs!: QueryList<NgbTabComponent>;
  @Input() activeId?: string;
  @Output() tabChange = new EventEmitter<any>();

  @Input() justify: 'start' | 'center' | 'end' | 'justified' | 'fill' = 'start';

  get navClasses(): string[] {
    const classes = [];

    switch (this.justify) {
      case 'justified':
        classes.push('nav-justified');
        break;
      case 'fill':
        classes.push('nav-fill');
        break;
      case 'center':
        classes.push('justify-content-center');
        break;
      case 'end':
        classes.push('justify-content-end');
        break;
      case 'start':
      default:
        // comportement par défaut (aligné à gauche)
        break;
    }

    return classes;
  }

  ngAfterContentInit() {
    console.log(this.tabs)
    if (!this.activeId) {
      const firstTab = this.tabs?.find(t => !t.disabled);
      if (firstTab) this.activeId = firstTab.id;
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['activeId']) {
      const activeTab = this.tabs?.find(t => '' + t.id === '' + this.activeId);
      if (!activeTab || activeTab.disabled) {
        const first = this.tabs?.find(t => !t.disabled);
        if (first) this.activeId = first.id;
      }
    }
  }

  selectTab(tab: NgbTabComponent) {
    if (tab.disabled) return;
    this.activeId = tab.id;
    this.tabChange.emit({ nextId: this.activeId });
  }

  get activeTab(): NgbTabComponent | undefined {
    return this.tabs?.find(t => t.id === this.activeId);
  }
}
